const BENEFITS = [
  {
    icon: 'ri-mic-line',
    title: 'Live ATC Transcription',
    desc: 'Every clearance, instruction, and readback captured in real time. Never miss a word from the tower again.',
    tag: 'Real-Time',
    color: 'from-[#00FFD1]/20 to-transparent',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Flight Performance Scoring',
    desc: 'AI grades every flight on approach stability, altitude deviations, speed control, and more — with actionable feedback.',
    tag: 'AI-Powered',
    color: 'from-[#00A3E0]/20 to-transparent',
  },
  {
    icon: 'ri-route-line',
    title: 'Pattern & Maneuver Analysis',
    desc: 'Visualize your traffic patterns, steep turns, and stalls. See exactly where you deviated and how to fix it.',
    tag: 'Visual',
    color: 'from-[#00FFD1]/20 to-transparent',
  },
  {
    icon: 'ri-brain-line',
    title: 'AI Coaching Insights',
    desc: 'Personalized post-flight debrief powered by AI. Get specific tips tailored to your skill level and training goals.',
    tag: 'Personalized',
    color: 'from-[#00A3E0]/20 to-transparent',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Preflight Inspection Checklist',
    desc: 'Smart, aircraft-specific checklists with voice guidance. Never skip a step on your walk-around again.',
    tag: 'Safety',
    color: 'from-[#00FFD1]/20 to-transparent',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Gamified Progress Tracking',
    desc: 'Earn badges, hit milestones, and track your logbook hours. Training has never felt this rewarding.',
    tag: 'Motivation',
    color: 'from-[#00A3E0]/20 to-transparent',
  },
];

export default function EarlyAccessBenefits() {
  return (
    <section className="py-24 px-6 bg-[#060E1E]">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-bold text-[#00FFD1] uppercase tracking-widest mb-3">What You Get</p>
          <h2 className="text-4xl font-extrabold mb-4">
            Everything a pilot needs to <span className="text-[#00FFD1]">level up</span>
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
            Early access members unlock the full WingmanFix feature suite — completely free during beta.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BENEFITS.map((b) => (
            <div
              key={b.title}
              className="group relative bg-white/4 border border-white/10 rounded-2xl p-7 hover:border-[#00FFD1]/40 hover:bg-white/6 transition-all duration-300 overflow-hidden"
            >
              {/* Gradient glow */}
              <div className={`absolute inset-0 bg-gradient-to-br ${b.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />

              <div className="relative z-10">
                {/* Icon + tag row */}
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#00FFD1]/10 border border-[#00FFD1]/20 group-hover:bg-[#00FFD1]/20 transition-all">
                    <i className={`${b.icon} text-[#00FFD1] text-2xl`} />
                  </div>
                  <span className="text-[10px] font-bold text-[#00FFD1]/70 uppercase tracking-widest bg-[#00FFD1]/10 border border-[#00FFD1]/20 rounded-full px-3 py-1">
                    {b.tag}
                  </span>
                </div>

                <h3 className="text-base font-bold text-white mb-2 group-hover:text-[#00FFD1] transition-colors">
                  {b.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            And much more coming in future updates —&nbsp;
            <a href="#signup-form" className="text-[#00FFD1] hover:underline cursor-pointer">
              join early to shape the roadmap
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
